import { useState } from "react";
import { XCircle, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "../../../lib/api";
import { Button } from "../../ui/button";
import { Label } from "../../ui/label";
import { Textarea } from "../../ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../../ui/dialog";

// ---------- Vertrag stornieren -------------------------------------------------
export function CancelContractModal({ listingId, hasInvoice = false, onClose, onDone }) {
    const [reason, setReason] = useState("");
    const [saving, setSaving] = useState(false);
    const submit = async () => {
        if (hasInvoice) { toast.error("Storno gesperrt: Rechnung vorhanden — bitte Stornorechnung/Gutschrift erstellen."); return; }
        if (!reason.trim()) { toast.error("Storno-Grund ist Pflicht"); return; }
        setSaving(true);
        try {
            await api.post(`/listings/${listingId}/dispo/cancel-contract`, { reason });
            toast.success("Vertrag storniert");
            await onDone?.();
            onClose();
        } catch (e) {
            toast.error(e.response?.data?.detail || "Stornierung fehlgeschlagen");
        } finally { setSaving(false); }
    };
    return (
        <Dialog open onOpenChange={(o) => !o && onClose()}>
            <DialogContent onPointerDownOutside={(e) => e.preventDefault()} onInteractOutside={(e) => e.preventDefault()} className="max-w-md" data-testid="dispo-modal-cancel">
                <DialogHeader><DialogTitle className="flex items-center gap-2"><XCircle className="w-5 h-5 text-red-600" /> Vertrag stornieren</DialogTitle></DialogHeader>
                {hasInvoice && (
                    <div className="bg-red-50 border border-red-300 rounded-sm p-3 text-xs text-red-800 font-bold" data-testid="dispo-cancel-invoice-block">
                        Storno gesperrt: Für dieses Fahrzeug existiert bereits eine Rechnung. Bitte zuerst eine Stornorechnung / Gutschrift erstellen.
                    </div>
                )}
                <Label className="text-xs font-bold uppercase tracking-wider">Storno-Grund *</Label>
                <Textarea value={reason} onChange={(e) => setReason(e.target.value)} rows={4} placeholder="z. B. Käufer ist vom Kauf zurückgetreten, Finanzierung geplatzt …" data-testid="dispo-cancel-reason" disabled={hasInvoice} />
                <DialogFooter>
                    <Button variant="outline" onClick={onClose}>Abbrechen</Button>
                    <Button onClick={submit} disabled={saving || hasInvoice} className="bg-red-600 hover:bg-red-700 text-white" data-testid="dispo-cancel-submit">
                        {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : "Vertrag stornieren"}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
